﻿import { Fragment, FunctionComponent, h } from 'preact';
import { KpiVisualiser } from './KPIVisualiser';
import styles from './KPIVisualiser.module.scss';
import { dateToXPos, GRID_MARGIN_TOP } from './Utils';

interface Props {
    zoom: number;
}
export const KpiVisualiser_TrackerLine: FunctionComponent<Props> = ({ zoom }) => {
    const nowX = dateToXPos(new Date(), zoom);
    const visualiserHeight = KpiVisualiser.instance?.props.domElement.clientHeight ?? 800.0;
    const markerPadding = 9.0;

    return (
        <>
            <marker id="playheadTriangle" viewBox="0 0 10 10" refX="1" refY="5" markerUnits="strokeWidth" markerWidth="8" markerHeight="5" orient="auto-start-reverse">
                <path d="M 10 0 L 0 5 L 10 10 z" class={styles.playheadMarker} />
            </marker>
            <line x1={nowX} y1={GRID_MARGIN_TOP + markerPadding} x2={nowX} y2={visualiserHeight - markerPadding}
                marker-start="url(#playheadTriangle)" marker-end="url(#playheadTriangle)"
                class={styles.playheadLine} pointer-events="none" />
        </>
    );
}
